import _objectWithoutProperties from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["isRevealed"],
  _excluded2 = ["isRevealed"];
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var __default__ = {
  name: "StaffsEdit"
};
import useSWRV from "swrv";
import emailValidator from "email-validator";
import { createData, getData, updateData, deleteData } from "@/services/axios";

import { useRoute, useRouter } from 'vue-router/composables';
import { inject, watch, ref } from 'vue';
import { isAuthenticatedKey, meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
import { useConfirmDialog } from '@vueuse/core';
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    // @ts-check
    var route = useRoute();
    var router = useRouter();
    var isAuthenticated = inject(isAuthenticatedKey);
    var me = inject(meKey);
    watch([me, isAuthenticated], function () {
      var _me$value;
      // 管理者以外の場合は Dashboard に戻す
      if (isAuthenticated.value && !((_me$value = me.value) !== null && _me$value !== void 0 && (_me$value = _me$value.allow) !== null && _me$value !== void 0 && _me$value.admin)) {
        router.push({
          name: "Dashboard"
        });
      }
    }, {
      immediate: true
    });
    var isCreate = ref(!route.params.id);
    var isLoading = ref({
      postData: false
    });
    var _useSWRV = useSWRV(function () {
        var _me$value2;
        return ((_me$value2 = me.value) === null || _me$value2 === void 0 || (_me$value2 = _me$value2.allow) === null || _me$value2 === void 0 ? void 0 : _me$value2.admin) && !isCreate.value && "staffs/".concat(route.params.id);
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getData("staffs/".concat(route.params.id), {
                with: "user"
              });
            case 1:
              result = _context.v;
              return _context.a(2, result.items);
          }
        }, _callee);
      })), {
        revalidateOnFocus: false,
        ttl: 2000
      }),
      staffBaseData = _useSWRV.data,
      isValidating = _useSWRV.isValidating;

    /** @returns {{ id: number; name: string; department: string; email: string; admin: boolean; forum_post: boolean; role_id: number }} */
    var setEditStaffData = function setEditStaffData() {
      var _staffBaseData$value$, _staffBaseData$value, _staffBaseData$value$2, _staffBaseData$value2, _staffBaseData$value$3, _staffBaseData$value3, _staffBaseData$value$4, _staffBaseData$value4, _staffBaseData$value$5, _staffBaseData$value5, _staffBaseData$value$6, _staffBaseData$value6;
      return {
        id: (_staffBaseData$value$ = (_staffBaseData$value = staffBaseData.value) === null || _staffBaseData$value === void 0 ? void 0 : _staffBaseData$value.id) !== null && _staffBaseData$value$ !== void 0 ? _staffBaseData$value$ : "",
        name: (_staffBaseData$value$2 = (_staffBaseData$value2 = staffBaseData.value) === null || _staffBaseData$value2 === void 0 ? void 0 : _staffBaseData$value2.name) !== null && _staffBaseData$value$2 !== void 0 ? _staffBaseData$value$2 : "",
        department: (_staffBaseData$value$3 = (_staffBaseData$value3 = staffBaseData.value) === null || _staffBaseData$value3 === void 0 ? void 0 : _staffBaseData$value3.department) !== null && _staffBaseData$value$3 !== void 0 ? _staffBaseData$value$3 : "",
        email: (_staffBaseData$value$4 = (_staffBaseData$value4 = staffBaseData.value) === null || _staffBaseData$value4 === void 0 ? void 0 : _staffBaseData$value4.email) !== null && _staffBaseData$value$4 !== void 0 ? _staffBaseData$value$4 : "",
        admin: (_staffBaseData$value$5 = (_staffBaseData$value5 = staffBaseData.value) === null || _staffBaseData$value5 === void 0 || (_staffBaseData$value5 = _staffBaseData$value5.allow) === null || _staffBaseData$value5 === void 0 ? void 0 : _staffBaseData$value5.admin) !== null && _staffBaseData$value$5 !== void 0 ? _staffBaseData$value$5 : false,
        forum_post: (_staffBaseData$value$6 = (_staffBaseData$value6 = staffBaseData.value) === null || _staffBaseData$value6 === void 0 || (_staffBaseData$value6 = _staffBaseData$value6.allow) === null || _staffBaseData$value6 === void 0 ? void 0 : _staffBaseData$value6.forum_post) !== null && _staffBaseData$value$6 !== void 0 ? _staffBaseData$value$6 : false,
        role_id: 9
      };
    };
    var staff = ref(setEditStaffData());
    watch(staffBaseData, function () {
      staff.value = setEditStaffData();
    });
    var resetError = function resetError() {
      return {
        name: "",
        department: "",
        email: ""
      };
    };
    var error = ref(resetError());
    var validateInput = function validateInput() {
      var valid = true;
      error.value = resetError();
      if (!staff.value.name) {
        error.value.name = "名前を入力してください。";
        valid = false;
      }
      if (!staff.value.department) {
        error.value.department = "所属を入力してください";
        valid = false;
      }
      if (!staff.value.email) {
        error.value.email = "メールアドレスを入力してください。";
        valid = false;
      } else if (!emailValidator.validate(staff.value.email)) {
        error.value.email = "メールアドレスの形式が正しくありません。";
        valid = false;
      }
      return valid;
    };
    var loadingMessage = ref("");
    var messageSettings = ref({
      title: "",
      message: ""
    });
    var _useConfirmDialog = useConfirmDialog(),
      isModalRevealed = _useConfirmDialog.isRevealed,
      modalDialog = _objectWithoutProperties(_useConfirmDialog, _excluded);
    var saveData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (validateInput()) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              staff.value.name = staff.value.name.replace(/\s+/, " ");
              isLoading.value.postData = true;
              _context2.p = 2;
              if (!isCreate.value) {
                _context2.n = 4;
                break;
              }
              loadingMessage.value = "職員情報を登録しています。";
              _context2.n = 3;
              return createData("staffs", staff.value);
            case 3:
              messageSettings.value = {
                message: "職員情報登録が完了しました",
                title: "登録完了"
              };
              _context2.n = 6;
              break;
            case 4:
              loadingMessage.value = "職員情報を更新しています。";
              _context2.n = 5;
              return updateData("staffs/" + route.params.id, staff.value);
            case 5:
              messageSettings.value = {
                message: "職員情報更新が完了しました",
                title: "更新完了"
              };
            case 6:
              _context2.n = 7;
              return modalDialog.reveal();
            case 7:
              _context2.n = 9;
              break;
            case 8:
              _context2.p = 8;
              _t = _context2.v;
              messageSettings.value = {
                message: "職員情報登録に失敗しました。既存の職員とメールアドレスが重複している可能性があります。",
                title: "エラー"
              };
              modalDialog.reveal();
              console.log(_t);
            case 9:
              _context2.p = 9;
              isLoading.value.postData = false;
              return _context2.f(9);
            case 10:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 8, 9, 10]]);
      }));
      return function saveData() {
        return _ref2.apply(this, arguments);
      };
    }();
    modalDialog.onConfirm(function () {
      return router.push({
        name: "Staffs"
      });
    });
    var _useConfirmDialog2 = useConfirmDialog(),
      isConfirmModalRevealed = _useConfirmDialog2.isRevealed,
      confirmModalDialog = _objectWithoutProperties(_useConfirmDialog2, _excluded2);
    confirmModalDialog.onConfirm(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var result, _t2, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return deleteData("staffs/" + route.params.id);
          case 1:
            result = _context3.v;
            if (!result.error_code) {
              _context3.n = 5;
              break;
            }
            _t2 = result.error_code;
            _context3.n = _t2 === 404 ? 2 : 3;
            break;
          case 2:
            messageSettings.value = {
              message: "職員の更新に失敗しました (Auth0 user not found)",
              title: "エラー"
            };
            return _context3.a(3, 4);
          case 3:
            messageSettings.value = {
              message: "職員の更新に失敗しました (" + result.errors + ")",
              title: "エラー"
            };
            return _context3.a(3, 4);
          case 4:
            _context3.n = 6;
            break;
          case 5:
            messageSettings.value = {
              message: "職員データを削除しました",
              title: "削除完了"
            };
          case 6:
            _context3.n = 8;
            break;
          case 7:
            _context3.p = 7;
            _t3 = _context3.v;
            messageSettings.value = {
              message: "職員データの削除に失敗しました",
              title: "エラー"
            };
            console.log(_t3);
          case 8:
            _context3.p = 8;
            modalDialog.reveal();
            return _context3.f(8);
          case 9:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 7, 8, 9]]);
    })));
    return {
      __sfc: true,
      route: route,
      router: router,
      isAuthenticated: isAuthenticated,
      me: me,
      isCreate: isCreate,
      isLoading: isLoading,
      staffBaseData: staffBaseData,
      isValidating: isValidating,
      setEditStaffData: setEditStaffData,
      staff: staff,
      resetError: resetError,
      error: error,
      validateInput: validateInput,
      loadingMessage: loadingMessage,
      messageSettings: messageSettings,
      isModalRevealed: isModalRevealed,
      modalDialog: modalDialog,
      saveData: saveData,
      isConfirmModalRevealed: isConfirmModalRevealed,
      confirmModalDialog: confirmModalDialog
    };
  }
});